import { fromLonLat } from 'ol/proj';

export const log = require('log-util');


export const STAGE = process.env.VUE_APP_STAGE || 'dev';

const BASE_URLS = {
  dev: 'https://api-dev.radarmeteo.com',
  ppr: 'https://api-ppr.radarmeteo.com',
  prod: 'https://api.radarmeteo.com'
};

export const BASE_URL = BASE_URLS[STAGE];

const BINARY_BASE_URLS = {
  dev: `${BASE_URL}/b2b-binary-dev`,
  ppr: `${BASE_URL}/b2b-binary-ppr`,
  prod: `${BASE_URL}/b2b-binary`
};

const API_BASE_URLS = {
  dev: `${BASE_URL}/b2b-dev`,
  ppr: `${BASE_URL}/b2b-ppr`,
  prod: `${BASE_URL}/b2b`
};

const ALERTEXPOST_BASE_URLS = {
  dev: `${BASE_URL}/utility-alert-dev`,
  ppr: `${BASE_URL}/utility-alert-ppr`,
  prod: `${BASE_URL}/utility-alert`
};

const REPORTS_BASE_URLS = {
  dev: `${BASE_URL}/utility-reports-dev`,
  ppr: `${BASE_URL}/utility-reports-ppr`,
  prod: `${BASE_URL}/utility-reports`
};

const CHECK_RESET_PASSWORD_BASE_URLS = {
  dev: `${BASE_URL}/check-reset-password-dev`,
  ppr: `${BASE_URL}/check-reset-password-ppr`,
  prod: `${BASE_URL}/check-reset-password`
};

const CADASTRAL_DATA_BASE_URLS = {
  dev: `${BASE_URL}/cadastral-data-dev`,
  ppr: `${BASE_URL}/cadastral-data-ppr`,
  prod: `${BASE_URL}/cadastral-data`
};

const GA_CODE_OBJ = {
  dev: '',
  ppr: 'G-ZYT55F7Q0P',
  prod: 'G-VPFHFFYQFQ'
};

const MAPBOX_TOKENS = {
  dev: 'pk.eyJ1IjoiYWNoaW5pIiwiYSI6ImNsajhqb214NzB0eW8zbm9ia3JvejVpemsifQ.ZnO-ZiZuVC7MGGEeQ_sz7Q',
  ppr: 'pk.eyJ1IjoiYWNoaW5pIiwiYSI6ImNsajhqb214NzB0eW8zbm9ia3JvejVpemsifQ.ZnO-ZiZuVC7MGGEeQ_sz7Q',
  prod: 'pk.eyJ1IjoicmFkYXJtZXRlbyIsImEiOiJjbGpjeGt2eXAyZGl1M2VxbjZmeTg4NW91In0.3EmW3z2VLg6M7XX7kVm_XQ'
};

export const getErrorMessage = err => {
  log.info(err);

  if (err) {
    if (err.message) {
      if (err.message.includes('length')) {
        return 'This element is empty';
      } else {
        if (
          err.message != null &&
          err.message != '' &&
          err.message != undefined
        ) {
          return err.message;
        }
      }
    } else {
      if (err.errors && err.errors[0] && err.errors[0].message) {
        if (err.errors[0].message.includes('RDS')) {
          const tmp = err.errors[0].message.split(':');
          tmp.shift();
          const error_message = tmp.join(':');

          return JSON.parse(error_message).message;
        } else {
          return err.errors[0].message;
        }
      }
    }
  }
};

export const BINARY_BASE_URL = BINARY_BASE_URLS[STAGE];

export const API_BASE_URL = API_BASE_URLS[STAGE];

export const ALERTEXPOST_BASE_URL = ALERTEXPOST_BASE_URLS[STAGE];

export const REPORTS_BASE_URL = REPORTS_BASE_URLS[STAGE];

export const CHECK_RESET_PASSWORD_BASE_URL = CHECK_RESET_PASSWORD_BASE_URLS[STAGE];

export const CADASTRAL_DATA_BASE_URL = CADASTRAL_DATA_BASE_URLS[STAGE];

export const LANGUAGES = ['en', 'it'];

export const S3_BUCKETS = {
  application: () => (STAGE === 'prod') ? 'radarmeteo-application-prd' : `radarmeteo-application-${STAGE}`,
  global_layer: () => (STAGE === 'prod') ? 'radarmeteo-global-layer-prd' : `radarmeteo-global-layer-${STAGE}`,
  customer: () => (STAGE === 'prod') ? 'radarmeteo-customer-prd' : `radarmeteo-customer-${STAGE}`
};

export const GA_CODE = GA_CODE_OBJ[STAGE];

export const MAPBOX_TOKEN = MAPBOX_TOKENS[STAGE];

export const MAPBOX_STYLE = {
  classic: STAGE === 'prod' ? 'radarmeteo/clmtakgib02j901r77mb45ljk' : 'achini/clmswkcv900j001qn6eova632',
  mountain: STAGE === 'prod' ? 'radarmeteo/clmtapfyf00lx01qnbpxx672x' : 'achini/clmt20vrs02e601r4etsag59s',
  satellite: STAGE === 'prod' ? 'radarmeteo/clmtaq4xn02hq01qx1yla9gw7' : 'achini/clmsy1yi002e401pf6ekw9p1m',
  light: STAGE === 'prod' ? 'radarmeteo/clmtan0ig02gn01pf87ijhzm4' : 'achini/clmt62ifk02ce01nzhad30t3n',
  grey: STAGE === 'prod' ? 'radarmeteo/cm2a72bli002201pg36j69sbu' : 'achini/cm1us640w016i01r2f2s61h8d',
  dark: STAGE === 'prod' ? 'radarmeteo/clmtam7zs02jd01r74317ekvp' : 'achini/clmt6nru302ea01pb5c73bysd'
};

export const MAP_STYLES = [
  { text: 'Classic', value: 'classic' },
  { text: 'Mountain', value: 'mountain' },
  { text: 'Satellite', value: 'satellite' },
  { text: 'Light', value: 'light' },
  { text: 'Grey', value: 'grey' },
  { text: 'Dark', value: 'dark' }
];

export const requestStates = ['SENT', 'TAKING CHARGE', 'DELETED', 'EMITTED'];

export const transform = (extent) => {
  return fromLonLat(extent, 'EPSG:4326', 'EPSG:3857');
};

log.info(STAGE);

export const METEOGRAM_LAYERS = ['TC2M_HOURLY', 'SKINTEMP_HOURLY', 'TDC2M_HOURLY', 'PREC_HOURLY', 'SNOW_HOURLY', 'PREC_CUM_HOURLY', 'SNOW_CUM_HOURLY', 'PREC_PROB_HOURLY', 'HAILPROB_HOURLY', 'WDIR10M_HOURLY', 'WSPD10M_HOURLY', 'GUST_HOURLY', 'VISIBILITY_HOURLY', 'LEAFWET_HOURLY', 'POTEVP_ACC_HOURLY', 'FROST_PROB_HOURLY', 'SOFTRIME_PROB_HOURLY', 'FRZRAIN_HOURLY'];

export const METEOGRAM_CONFIG = {
  lineType: ['TC2M_HOURLY', 'SKINTEMP_HOURLY', 'TDC2M_HOURLY', 'WSPD10M_HOURLY', 'GUST_HOURLY'],
  areaType: ['PREC_CUM_HOURLY', 'SNOW_CUM_HOURLY', 'POTEVP_ACC_HOURLY'],
  rightYAxis: ['PREC_CUM_HOURLY', 'SNOW_CUM_HOURLY', 'LEAFWET_HOURLY'],
  windDirectionLayer: ['WDIR10M_HOURLY'],
  chartVariables: {
    meteogram1: {
      variable: ['TC2M_HOURLY', 'SKINTEMP_HOURLY', 'TDC2M_HOURLY'],
      minMaxLeft: [0, 30],
      minMaxRight: [],
      labelLeft: [],
      labelRight: []
    },
    meteogram2: {
      variable: ['PREC_HOURLY', 'SNOW_HOURLY', 'PREC_CUM_HOURLY', 'SNOW_CUM_HOURLY', 'FRZRAIN_HOURLY'],
      minMaxLeft: [0, 10],
      minMaxRight: [0, 100],
      labelLeft: ['Meteogram2.yLabelLeftDouble'],
      labelRight: ['Meteogram2.yLabelRight', 'Meteogram2.yLabelRightDouble']
    },
    meteogram3: {
      variable: ['PREC_PROB_HOURLY', 'HAILPROB_HOURLY'],
      minMaxLeft: [0, 100],
      minMaxRight: [],
      labelLeft: [],
      labelRight: []
    },
    meteogram7: {
      variable: ['FROST_PROB_HOURLY', 'SOFTRIME_PROB_HOURLY'],
      minMaxLeft: [0, 100],
      minMaxRight: [],
      labelLeft: [],
      labelRight: []
    },
    meteogram4: {
      variable: ['WSPD10M_HOURLY', 'GUST_HOURLY'],
      minMaxLeft: [0, 20],
      minMaxRight: [],
      labelLeft: [],
      labelRight: []
    },
    meteogram5: {
      variable: ['VISIBILITY_HOURLY'],
      minMaxLeft: [0, 5000],
      minMaxRight: [],
      labelLeft: [],
      labelRight: []
    },
    meteogram6: {
      variable: ['LEAFWET_HOURLY', 'POTEVP_ACC_HOURLY'],
      minMaxLeft: [0, 30],
      minMaxRight: [0, 1],
      labelLeft: [],
      labelRight: ['Meteogram6.yLabelRight']
    }
  }
};
